import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { tuiTablePaginationOptionsProvider } from "@taiga-ui/addon-table";
import { throwErrorMessage } from "../../../../helpers/kwikui.common.helpers";
import {
  DEFAULT_VALUES,
  VALIDATE_KEY_VALUES
} from "./table-pagination.constants";
import { isValidKeyValue } from "./table-pagination.validation";

@Component({
  selector: "kwikui-table-pagination",
  templateUrl: "./table-pagination.component.html",
  providers: [
    tuiTablePaginationOptionsProvider({
      showPages: false
    })
  ],
  styleUrls: ["./table-pagination.component.scss"]
})
export class KwikUITablePaginationComponent implements OnInit, OnChanges {
  @Input() id: string = DEFAULT_VALUES.id;

  @Input() page: number = DEFAULT_VALUES.page;

  @Input() size: number = DEFAULT_VALUES.size;

  @Input() total: number = DEFAULT_VALUES.total;

  @Output() onClick = new EventEmitter<any>();

  @Output() pageChange = new EventEmitter<any>();

  @Output() sizeChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-table-pagination",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  handleOnClick(e: any): void {
    this.onClick.emit(e);
  }

  onPageChange(e: any): void {
    this.pageChange.emit(e);
  }

  onSizeChange(e: any): void {
    this.sizeChange.emit(e);
  }
}
